// 관리대책 폼 필수 입력 검증 — [관리대책 선택] 체크박스 또는 [추가 관리대책] 텍스트
// 둘 중 하나는 반드시 입력되어야 한다. 위반 시 components/basics/alert 다이얼로그 표시.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { alertId: String }

  validate(event) {
    const form = this.element
    const anyMeasureChecked = form.querySelector('input[name="management_control[measures][]"]:checked') != null
    const extra = form.querySelector('textarea[name="management_control[extra_measures]"]')
    const hasExtra = extra && extra.value.trim() !== ""

    // 모달 모드 (improvement_plans 화면) 에서만 렌더되는 추진상황 / 개선 목표일 — 있으면 필수.
    const progressEl = form.querySelector('input[name="management_control[progress_status]"]')
    const targetEl   = form.querySelector('input[name="management_control[target_quarter]"]')
    const progressMissing = progressEl && progressEl.value.trim() === ""
    const targetMissing   = targetEl && targetEl.value.trim() === ""

    // [개선필요 여부] 라디오 — 필수. 'true' 선택 시 [관리 우선순위] 도 필수.
    const needsImpEl = form.querySelector('input[name="management_control[needs_improvement]"]:checked')
    const needsImpMissing = !needsImpEl
    const needsImpTrue = needsImpEl && needsImpEl.value === 'true'
    const priorityEl = form.querySelector('input[name="management_control[priority]"]:checked')
    const priorityMissing = needsImpTrue && !priorityEl

    let message = null
    if (!anyMeasureChecked && !hasExtra) {
      message = "[관리대책 선택] 또는 [추가 관리대책] 항목 중 적어도 하나에 입력값이 있어야 합니다."
    } else if (needsImpMissing) {
      message = "[개선필요 여부] 를 선택해주세요."
    } else if (priorityMissing) {
      message = "[관리 우선순위] 를 선택해주세요."
    } else if (progressMissing) {
      message = "[추진상황] 을 선택해주세요."
    } else if (targetMissing) {
      message = "[개선 목표일] 을 선택해주세요."
    }

    if (message) {
      event.preventDefault()
      event.stopImmediatePropagation()
      event.stopPropagation()
      const alertEl = document.getElementById(this.alertIdValue)
      if (alertEl) {
        const msgEl = alertEl.querySelector("[data-alert-target='body'] p")
        if (msgEl) msgEl.textContent = message
        alertEl.dispatchEvent(new CustomEvent("alert:open"))
      }
    }
  }
}
